import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Styles from "./manageMenu.module.scss";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { useDispatch, useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import useTask from "../../hooks/useTask";
import { addDisabledRoute, removeDisabledRoute } from "../../actions/disabledRoutes";
import CloseIcon from "@material-ui/icons/Close";
import { ReactComponent as SetupMenuSVG } from '../../assets/images/icon-setup-menu.svg';
import { ReactComponent as SquareTickSVG } from '../../assets/images/icon-square-tick.svg';
import { MenuContainerTabsNested } from "../Routes";
import MessageBox from "../../yoello-lib/modules/components/UI/MessageBox/MessageBox";
import { ReactComponent as Circle } from "../../assets/images/icon-info-circle.svg";

const MenusSetupDialog = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
  const Venue = useSelector(
    (state: IReduxAppState) => state.venue[venueId]?.venueSettings
  );
  const { callAPI } = useAPIV2(APIExtensions.menuMigration, {
    onMountDisabled: true,
  });
  const outstandingData = useSelector(
    (state: IReduxAppState) => state.outstanding.body
  );
  useEffect(() => {
    if (outstandingData[0]?.items[0]?.complete === false) {
      // @ts-ignore
      dispatch(addDisabledRoute(MenuContainerTabsNested.PRODUCTS.items.MANAGE_MENU.key))
    }
    // eslint-disable-next-line
  }, [outstandingData])
  useEffect(() => {
    if (Venue?.on_menu_setup === false) {
      setDialogOpen(true)
      // @ts-ignore
      dispatch(addDisabledRoute(MenuContainerTabsNested.PRODUCTS.items.MANAGE_MENU.key))
    } else {
      // @ts-ignore
      dispatch(removeDisabledRoute(MenuContainerTabsNested.PRODUCTS.items.MANAGE_MENU.key));
    }
    // eslint-disable-next-line
  }, [venueId])

  const { increaseDoneTasks } = useTask();

  async function onClick() {
    setIsLoading(true);

    await callAPI(HTTPMethods.POST, {
      body: {
        venue_id: venueId
      }
    })

    increaseDoneTasks();
    setIsLoading(false);
    // @ts-ignore
    dispatch(removeDisabledRoute(MenuContainerTabsNested.PRODUCTS.items.MANAGE_MENU.key));
    setDialogOpen(false)
    window.location.reload()
  }

  const summaryOfChangesTexts = [
    "manageMenu.menuSetup.change1",
    "manageMenu.menuSetup.change2",
    "manageMenu.menuSetup.change3",
    "manageMenu.menuSetup.change4",
  ]
  return (
    <Dialog
      onClose={() => { if (!isLoading) setDialogOpen(false); }}
      open={dialogOpen}
      className="outstanding"
    >
      <div className={Styles.menusSetup}>
        <div className={Styles.topIcon}>
          <SetupMenuSVG />
        </div>
        <div className={Styles.closeIcon}>
          <CloseIcon onClick={() => { if (!isLoading) setDialogOpen(false); }} />
        </div>
        <h3 className={Styles.title}>{t("manageMenu.menuSetup.title")}</h3>
        <p className={Styles.intro}>
          {t("manageMenu.menuSetup.description1")}
        </p>
        <div>
          <p className={Styles.SummaryOfChangesText}>{t("manageMenu.menuSetup.SummaryOfChanges")}</p>
          {summaryOfChangesTexts.map((item, i) => {
            return <div key={`MenuSetupChangesText${i}`} className={Styles.SummaryOfChangesDiv}>
              <div>
                <SquareTickSVG width="15" height="15" />
              </div>
              <p>{t(item)}</p>
            </div>
          })}

        </div>
        <p className={Styles.intro2}>{t("manageMenu.menuSetup.description2")}</p>

        <Button
          className={Styles.submit}
          variant="contained"
          color="primary"
          size="large"
          onClick={onClick}
          disabled={isLoading}
        >
          {t("manageMenu.menuSetup.UpdateToNewMenu")}
        </Button>

        <div style={{
          marginTop: "2.5rem"
        }}>
          <MessageBox icon={<Circle />} buttonURL="https://faq.yoello.com/knowledge/how-do-i-set-up-a-menu" buttonText={t("manageMenu.menuSetup.FAQButton")} title={t("manageMenu.menuSetup.FAQTitle")} buttonBefore={t("manageMenu.menuSetup.FAQDescription")} />

        </div>
      </div>
    </Dialog>
  );
};

export default MenusSetupDialog;
